<div>
  <div class="modal_header">
    @if (mode==='edit') {
      <i class="fa fa-pencil-alt header-icon"></i>
      <p>EDIT PORTFOLIO</p>
    } @else {
      <i class="fa fa-pencil-alt header-icon"></i>
      <p>CREATE PORTFOLIO</p>
    }
  </div>
  <div class="modal__content">
    <form [formGroup]=portfolioForm (submit)="submit()">
      @if (portfolioForm) {
        <div class="mb-3">
          <label class="control-label" for="name">Name</label>
          <input
            [ngClass]="{'is-invalid': (portfolioForm.touched || portfolioForm.dirty) && portfolioForm.invalid}"
            type="text" class="form-control" id="name" formControlName="name">
          @if (portfolioForm.get('name').hasError('formIsUnchanged')) {
            <span class="invalid-feedback"
              >
              No changes have been made
            </span>
          }
          @if (portfolioForm.get('name').hasError('maxlength')) {
            <span class="invalid-feedback"
              >
              Maximum of 30 characters
            </span>
          }
          @if (portfolioForm.get('name').hasError('pattern')) {
            <span class="invalid-feedback"
              >
              Portfolio contains invalid characters
            </span>
          }
          @if (portfolioForm.get('name').hasError('required')) {
            <span class="invalid-feedback"
              >
              Portfolio Name is required
            </span>
          }
        </div>
      }
      @if (portfolioForm.invalid && portfolioForm.hasError('formIsUnchanged')) {
        <div class="error-block">
          No changes have been made
        </div>
      }
      <div class="modal__footer">
        <div class="footer-action-buttons">
          <button type="reset" class="btn btn-link" (click)="closeModal()">Cancel</button>
          <button type="submit" class="btn btn-primary">{{this.mode === 'edit' ? 'Save' : 'Submit'}}</button>
        </div>
      </div>
    </form>
  </div>
</div>
